import { render } from "./FormTitle.vue?vue&type=template&id=2252df39"
import script from "./FormTitle.vue?vue&type=script&lang=js"
export * from "./FormTitle.vue?vue&type=script&lang=js"

import "./FormTitle.vue?vue&type=style&index=0&id=2252df39&lang=css"
script.render = render

export default script